import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Button from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Button';
import { noop } from 'Helpers/PropTypes';

const styles = (theme) => ({
  root: {
    minWidth: 32,
    height: 32,
    borderRadius: '50%',
    color: theme.palette.common.white,
    fontWeight: 'medium',
    margin: theme.spacing(1, 0),
  },
  available: {
    backgroundColor: theme.palette.facet.accentBlue2,
  },
  someAvailability: {
    backgroundColor: theme.palette.facet.accentBlue20,
    color: theme.palette.facet.primaryBlue,
  },
  noAvailability: {
    backgroundColor: theme.palette.facet.mediumGray3,
    color: theme.palette.facet.primaryGray,
    '&:disabled': {
      backgroundColor: theme.palette.facet.mediumGray3,
      color: theme.palette.facet.primaryGray,
    },
  },
});

const SchedulerDayButton = ({
  capacity,
  className,
  classes,
  day,
  handleDayNumberClick,
  inCurrentMonth,
  test,
  isWeekday,
}) => {
  return (
    <Button
      className={classNames(className, classes.root, {
        [classes.available]: capacity > 2,
        [classes.someAvailability]: capacity === 1 || capacity === 2,
        [classes.noAvailability]: capacity === 0 || !isWeekday,
      })}
      test={inCurrentMonth ? test : undefined}
      onClick={isWeekday ? handleDayNumberClick : noop}
      disabled={capacity === 0}
    >
      {day}
    </Button>
  );
};

SchedulerDayButton.defaultProps = {
  className: '',
};

SchedulerDayButton.propTypes = {
  capacity: PropTypes.number.isRequired,
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  day: PropTypes.number.isRequired,
  handleDayNumberClick: PropTypes.func.isRequired,
  inCurrentMonth: PropTypes.bool.isRequired,
  isWeekday: PropTypes.bool.isRequired,
  test: PropTypes.string.isRequired,
};

export default withStyles(styles)(SchedulerDayButton);
